<template>
  <v-container grid-list-md text-md-center>
    <Loading v-model="loading"></Loading>
    <v-layout row wrap class="my-page">
      <v-flex xl8 offset-xl2 xs12>
        <div class="Title">
          マイページ
        </div>
      </v-flex>


      <v-flex xl8 offset-xl2 xs12>
        <div class="subTitle"><span>お知らせ</span></div>
        <template v-for="info in eventInfoConditionalTextsOrdered" v-if="rule(info)">
          <p class="text-left ql-editor" v-html="info.text"></p>
        </template>
      </v-flex>

      <v-flex xl8 offset-xl2 xs12 v-if="canShowWrittenResult && me.examResult && !!me.examResult.writtenResult"
              id="result">
        <div class="subTitle"><span>試験結果情報</span></div>
        <p>{{ event.eventName }}の<span v-if="canShowOralResult">結果</span><span v-else>筆記試験結果</span>について、次のとおり通知します。
        </p>


        <template v-if="canShowOralResult && (!!me.examResult.oralResult || !!me.examResult.oralResult2)"
                  && (me.examResult.writtenResult !='不合格' || !!me.subjectEntry.language2)>

          <div style="border: solid 5px #fbc001; margin-bottom:2rem;" class="px-5">

            <h2 class="mt-5">{{ event.eventName }}結果 </h2>


            <table class="ma-auto text-left" v-if="me.examResult.resultDetail" style="font-size: 1.4rem">
              <tr v-if="!!me.examResult.oralResult">
                <th>受験外国語</th>
                <th style="padding: 0 3rem">{{ me.subjectEntry.language1.title }}</th>
                <td>{{ me.examResult.oralResult }}</td>
              </tr>
              <tr v-if="!!me.subjectEntry.language2 && !!me.examResult.oralResult2">
                <th>受験第二外国語</th>
                <th style="padding: 0 3rem">{{ me.subjectEntry.language2.title }}</th>
                <td>{{ me.examResult.oralResult2 }}</td>
              </tr>
            </table>

            <template v-if="me.examResult.writtenResult == '合格' && me.examResult.oralResult == '不合格'">
              <h2 class="mt-5">受験外国語</h2>
              <v-btn rounded large
                     color="blue-grey"
                     :to="`/api/visitor/${event.id}/certificate`"
                     target="_blank"
                     style="font-size: 22px"
                     class="white--text buttonStyle">筆記試験合格証書閲覧
              </v-btn>
            </template>

            <template v-if="me.examResult.oralResult == '合格'">
              <h2 class="mt-5">受験外国語</h2>
              <v-btn rounded large
                     color="blue-grey"
                     :to="`/api/visitor/${event.id}/certificate/oral1`"
                     target="_blank"
                     style="font-size: 22px"
                     class="white--text buttonStyle">合格証書閲覧
              </v-btn>
            </template>

            <template v-if="!!me.subjectEntry.language2 && me.examResult.oralResult2 == '合格'">
              <h2 class="mt-5">受験第二外国語</h2>
              <v-btn rounded large
                     color="blue-grey"
                     :to="`/api/visitor/${event.id}/certificate/oral2`"
                     target="_blank"
                     style="font-size: 22px"
                     class="white--text buttonStyle">合格証書閲覧
              </v-btn>
            </template>

            <div v-if="me.examResult.oralResult == '合格' || me.examResult.oralResult2 == '合格'" class="text-left mt-1"
                 style="line-height: 2em">
              <div class="ql-editor" v-if="eventInfo.myPageSuccessResultNotice" v-html="eventInfo.myPageSuccessResultNotice">
              </div>
              <template v-else>
                <h3 class="my-3">合格者の皆さまへお知らせ</h3>
                合格された方は、<br/>
                ① 都道府県への登録のご案内、<br/>
                ② 全国通訳案内士登録についてのお問い合せ先、<br/>
                ③ 通訳案内士関係団体のご紹介、<br/>
                ④ 通訳案内士登録情報検索サービスのご案内、<br/>
                が記載された
                <v-btn text class="text--darken-4 blue--text text-decoration-underline font-weight-bold v-size--x-large"
                       target="_blank"
                       href="https://cdn.shiken.jnto.go.jp/doc/%E5%90%88%E6%A0%BC%E8%80%85%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8%E3%81%AE%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B.pdf">
                  【合格者の皆様へのお知らせ】
                </v-btn>
                を、マイページが閉鎖する2月29日までに必ずご確認ください。<br/>
                ※上記、下線部をクリックするとお知らせが掲載されているページが開きます。
              </template>
            </div>

            <div class="text-left mt-1 ql-editor" v-if="eventInfo.myPageResultNotice" v-html="eventInfo.myPageResultNotice">
            </div>
            <div class="text-left mt-1" style="line-height: 2em" v-else>
              ※口述試験合格者には合格証書、口述試験不合格者のうち筆記試験合格者には筆記試験合格証書の閲覧ボタンが<br/>
              上記に表示されます。該当者はそれぞれの証書をご確認ください。<br/>
              合格証書、筆記試験合格証書は一部のソフトで閲覧ができない場合がございます。<br/>
              閲覧できない場合は、以下の推奨環境にて閲覧をお願いいたします。<br/>
              また、閲覧ページより紙への印刷、データの保存が可能です。マイページが閉鎖する2026年2月28日までに合格証書、筆記試験合格証書の印刷やデータの保存を行ってください。<br/>
              <div class="text-left mt-1  mx-4">
                【閲覧推奨環境】<br/>
                ブラウザ：Google Chrome、Mozilla Firefox、Safari、Microsoft Edge<br/>
                閲覧ソフト：Adobe Acrobat Reader<br/>
                ※ Adobe Acrobat Readerは下記よりダウンロードいただけます。<br/>
                <a target="_blank" href="https://get.adobe.com/jp/reader/?promoid=TTGWL47M"
                   class="text-decoration-underline">
                  https://get.adobe.com/jp/reader/?promoid=TTGWL47M
                </a>
              </div>
              <span class="red--text font-weight-bold">※来年度以降の全国通訳案内士試験で免除申請をされる場合、免除資格を得た年度の受験番号等の情報が必要となります。マイページが閉鎖する2026年2⽉28⽇までに必要事項は必ずお控えください。<br/>
            なお、閲覧停⽌後の再閲覧や掲載情報の問い合わせ等には応じられませんので、ご注意ください。</span><br/>
              ※システムにご登録の氏名等に誤りがある場合は、お問い合わせ先の全国通訳案内士事務局へ2月13日（火）17：00
              までに必ずご連絡ください。
            </div>
          </div>
        </template>

        <table class="ma-auto text-left" v-if="me.examResult.resultDetail" style="vertical-align: top">
          <tr>
            <td>
              <h3 class="text-left">筆記試験結果</h3>
            </td>
            <td colspan="2" style="padding: 0 3rem">{{ me.examResult.writtenResult }}
              (受験外国語：{{ me.subjectEntry.language1.title }})
            </td>
          </tr>
          <tr v-if="!!me.subjectEntry.language2">
            <td></td>
            <td colspan="2" style="padding: 0 3rem">{{ me.examResult.writtenResult2 }}
              (受験第二外国語：{{ me.subjectEntry.language2.title }})
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <h3 class="mt-4 text-left">科目別詳細</h3>
            </td>
          </tr>
          <tr>
            <th class="pl-6">受験外国語</th>
            <th style="padding: 0 3rem">{{ me.subjectEntry.language1.title }}</th>
            <td v-if="eventInfo.doesShowResultScore" class="resultScore">
              <span v-if="me.examResult.resultDetail.writtenLanguageScore">{{
                  me.examResult.resultDetail.writtenLanguageScore
                }}点</span>
            </td>
            <td>{{ me.examResult.resultDetail.writtenLanguageResult }}</td>
          </tr>
          <tr v-if="!!me.subjectEntry.language2">
            <th class="pl-6">受験第二外国語</th>
            <th style="padding: 0 3rem">{{ me.subjectEntry.language2.title }}</th>
            <td v-if="eventInfo.doesShowResultScore" class="resultScore"></td>
            <td>免除</td>
          </tr>
          <tr>
            <th colspan="2" class="pl-6">日本地理</th>
            <td v-if="eventInfo.doesShowResultScore" class="resultScore">
              <span v-if="me.examResult.resultDetail.writtenGeographyScore">{{
                  me.examResult.resultDetail.writtenGeographyScore
                }}点</span>
            </td>
            <td>{{ me.examResult.resultDetail.writtenGeographyResult }}</td>
          </tr>
          <tr>
            <th colspan="2" class="pl-6">日本歴史</th>
            <td v-if="eventInfo.doesShowResultScore" class="resultScore">
              <span v-if="me.examResult.resultDetail.writtenHistoryScore">{{
                  me.examResult.resultDetail.writtenHistoryScore
                }}点</span>
            </td>
            <td>{{ me.examResult.resultDetail.writtenHistoryResult }}</td>
          </tr>
          <tr>
            <th colspan="2" class="pl-6">一般常識</th>
            <td v-if="eventInfo.doesShowResultScore" class="resultScore">
              <span v-if="me.examResult.resultDetail.writtenCommonSenseScore">{{
                  me.examResult.resultDetail.writtenCommonSenseScore
                }}点</span>
            </td>
            <td>{{ me.examResult.resultDetail.writtenCommonSenseResult }}</td>
          </tr>
          <tr>
            <th colspan="2" class="pl-6">通訳案内の実務</th>
            <td v-if="eventInfo.doesShowResultScore" class="resultScore">
              <span v-if="me.examResult.resultDetail.writtenPracticeScore">{{
                  me.examResult.resultDetail.writtenPracticeScore
                }}点</span>
            </td>
            <td>{{ me.examResult.resultDetail.writtenPracticeResult }}</td>
          </tr>
        </table>

        <p class="text-left mt-3">
          【結果に関する用語の解説】<br/>
          ＜筆記試験結果について＞<br/>
          「合格」：口述試験の受験資格があります。免除科目がなく、受験した5科目全てで合格基準点を満たした方が対象となります。口述試験が不合格となった場合には、筆記試験のみの合格証書が発行されます。<br/>
          「通過」：口述試験の受験資格があります。いずれかの科目に免除が含まれる方で、受験した科目全てで合格基準点を満たした方が対象となります。通過の方は口述試験が不合格となった場合も筆記試験の合格証書は発行されません。<br/>
          「不合格」：口述試験の受験資格はありません。<br/>
          <br/>
          ＜科目別詳細について＞<br/>
          「合格」：受験して合格基準点を満たした科目です。<br/>
          「免除」：免除申請が受理され、受験が免除となった科目です。<br/>
          「不合格」：受験して合格基準点を満たさなかった科目です。また、試験を欠席した方も該当します。
        </p>
        <p class="text-left mt-3">
          <span>
            ※⼆か国語受験をされた⽅で、筆記試験を受験された外国語が不合格であっても、他の４科⽬が全て合格⼜は免除の場合には、第⼆外国語（筆記試験が免除となった外国語）の⼝述試験の受験資格がございます。
          </span><br/>
          ※2025年度に合格または免除となった科目の来年度以降の免除可否については当該年度の全国通訳案内士試験ガイドラインをご確認ください。<br/>
          <span class="font-weight-bold red--text">
          ※来年度以降の全国通訳案内士試験で科目免除を申請する場合、免除資格を得た年度の受験番号等の情報が必要となります。受験番号、合格科目等が分かるようにお手元に保管してください。<br/>
          ※マイページは 2026年2⽉28⽇まで閲覧が可能クレジットカード払いの場合は申込み時に、コンビニ払いの場合は支払期限内のお支払いをお願いいたします。です。2025年3⽉1⽇より閲覧できなくなりますので、必要事項は必ず事前にお控えください。</span><br/>
          なお、閲覧停⽌後の再閲覧や掲載情報の問い合わせ等には応じられませんので、ご注意ください。
        </p>

      </v-flex>

      <v-flex xl8 offset-xl2 xs12>
        <div class="subTitle">
          <span>登録情報</span>
        </div>
      </v-flex>
      <v-flex xl8 offset-xl2 xs12>
        <v-text-field label="メールアドレス" :value="me.username" readonly class="mx-5"
                      append-icon="mdi-pencil"
                      @click:append="changeEmailModal = true"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="changeEmailModal = true">
                  <v-icon v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>メールアドレスの変更</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="changePasswordModal = true">
                  <v-icon v-bind="attrs" v-on="on">mdi-account-key</v-icon>
                </v-btn>
              </template>
              <span>パスワードの変更</span>
            </v-tooltip>

            <!--            <v-btn color="primary" text @click="changeEmailModal = true">メールアドレスの変更</v-btn>-->
            <!--            <v-btn color="primary" text>パスワードの変更</v-btn>-->
          </template>
        </v-text-field>
        <!--          </v-col>-->
        <!--        </v-row>-->

      </v-flex>
      <v-flex xl8 offset-xl2 xs12 v-if="canShowWrittenTicket && accepted">
        <h3 class="mt-5">受験番号 {{ me.examineesNumber }}</h3>

        <v-img :src="`/api/visitor/me/${event.id}/qr`" width="150" height="150" class="ma-auto"></v-img>

        <v-btn rounded
               :disabled="!canShowWrittenTicket"
               color="blue-grey"
               :to="`/api/visitor/${event.id}/ticket`"
               target="_blank"
               class="white--text buttonStyle">筆記試験受験票ダウンロード
        </v-btn>
      </v-flex>

      <v-flex xl8 offset-xl2 xs12 v-if="canShowOralTicket
      && me.examResult
      && me.examResult.canTakeOralExam">
        <v-btn rounded
               color="blue-grey"
               tag="a"
               :href="`/api/visitor/${event.id}/oral_ticket`"
               target="_blank"
               class="white--text buttonStyle">口述試験受験票ダウンロード
        </v-btn>
      </v-flex>

      <v-container>
      </v-container>
      <v-flex xl8 offset-xl2 xs12>
        <div class="subTitle"><span>願書申請状況</span></div>

        <p class="info-text ql-editor" v-if="eventInfo.myPageNotice" v-html="eventInfo.myPageNotice">
        </p>
        <template v-else>
          <div>【電子申請入力の注意事項】</div>
          <p class="text-caption text-left">
            願書申請の手順は下記のとおりです。注意事項をご確認の上、申請してください。<br>
            【願書申請手順】<br>
            　①受験者情報の登録<br>
            　②受験科目・希望受験地・免除申請の登録<br>
            　③受験手数料お支払いの手続き<br>
            　④願書の提出<br>
            <br>
            【登録状況の確認方法】<br>
            　各項目の右側のマークでご確認いただけます。<br>


            　
            <v-icon color="gray">mdi-check-circle</v-icon>
            黒チェックマーク：登録未完了（必須項目に未入力、未登録の項目がある状況です）<br>
            　
            <v-icon color="green">mdi-check-circle</v-icon>
            緑チェックマーク：登録完了（必須項目が全て入力・登録され、願書提出ができる状況です）<br>
            　<span style="border-radius: 50%" class="v-stepper__step__step primary">
          <v-icon color="white">edit</v-icon></span>鉛筆マーク：登録内容の修正・変更が可能<br>
            　　※願書提出後は、時期により変更可能な項目が異なります。詳細は、トップページの施行要領「登録変更早見表」を<br>
            　　　ご確認ください。<br>
            <br>
            【電子申請入力の注意事項】<br>
            ※下記①～③全ての入力及び手続きが完了するまで「願書提出」ができません。<br>
            　申請期間終了後は「願書提出」ができませんのでご注意ください。<br>
            ※「願書を提出する」ボタンを押し、願書を提出するまでは、入力内容の修正・変更が可能です。<br>
            ※「願書提出」後、全国通訳案内士試験事務局にて申請書類を審査いたします。<br>
            　審査が完了し、申請内容が承認されるとご登録いただいたメールアドレス宛に「受験願書「承認」のお知らせ」が送付され、　　<br>
            　マイページ上でも「審査状況」がご確認いただけます。<br>
            ※受験願書申請が「承認」された方のみ全国通訳案内士試験を受験いただけます。<br>
            ※入力情報、写真、免除書類等に不備があった場合は、事務局より修正依頼のご連絡をいたします。<br>
            　期日までに修正が完了しない場合は「承認完了」ができず、受験することができませんのでご注意ください。<br>
            <br>
            【願書提出後の受験者情報の変更】<br>
            願書提出後、入力した項目に変更があった場合は、「受験者情報の登録」で上書き変更をしてください。<br>
            項目により変更可能期限が異なります。また、項目により変更内容を証明する書類の提出が必要です。<br>
            詳細は 施行要領P.10~12 をご確認ください。<br>
            施行要領　<a
            href="https://www.jnto.go.jp/jpn/projects/visitor_support/interpreter_guide_exams/operation_2021.pdf"
            target="_blank">https://www.jnto.go.jp/jpn/projects/visitor_support/interpreter_guide_exams/operation_2021.pdf</a>
          </p>
        </template>

        <v-stepper
          v-model="stepper"
          vertical
          flat
        >
          <v-stepper-step
            :complete="entryOk"
            step="1"
            editable
            class="open_force"
          >
            <span>受験者情報の登録
            <v-icon color="green" v-if="entryOk">mdi-check-circle</v-icon>
            <v-icon color="gray" v-else>mdi-check-circle</v-icon>
            </span>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-btn color="primary" to="/entry" rounded
                   class="white--text buttonStyle">登録画面に進む
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :editable="subjectOk"
            :complete="subjectOk"
            step="2"
            class="open_force"
          >
            <span>
            受験科目・希望受験地・免除申請の登録
            <v-icon color="green" v-if="subjectOk">mdi-check-circle</v-icon>
            <v-icon color="gray" v-else>mdi-check-circle</v-icon>
            </span>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-btn color="primary" rounded :disabled="!entryOk" :to="entryOk ? '/select' : null"
                   class="white--text buttonStyle">登録画面に進む
            </v-btn>


          </v-stepper-content>

          <v-stepper-step
            :complete="!!me.ticketOrder"
            step="3"
          >
            <span>
            受験手数料支払い手続き
            <v-icon color="green" v-if="paymentOk">mdi-check-circle</v-icon>
            <v-icon color="gray" v-else>mdi-check-circle</v-icon>
              </span>
          </v-stepper-step>

          <v-stepper-content step="3">
            <template v-if="entryOpened || isPre">
              <v-radio-group v-model="paymentMethod" class="pl-3">
                <v-sheet class="text-caption pa-3 mb-6" outlined>
                  【クレジットカード】<br>
                  VISA、MASTER、JCB、AMEX、DINERS、DISCOVER が使用できます。<br>
                  一カ国語受験・・・15,345 円（受験手数料 14,850 円＋事務手続手数料 495 円）<br>
                  二カ国語受験・・・30,686 円（受験手数料 29,700 円＋事務手続手数料 986 円）
                </v-sheet>

                <v-radio
                  label="クレジットカード決済"
                  value="card"
                  :checked="true"
                ></v-radio>
                <v-container class="text-center">
                  <v-text-field v-model="callbackCard" readonly v-if="false">
                    <template v-slot:append>
                      <v-btn @click="openCardInput" outlined color="info">カード情報の入力</v-btn>
                    </template>
                  </v-text-field>
                  <v-btn @click="openCardInput" outlined color="info"
                         :disabled="paymentMethod!='card'">
                    <span v-if="callbackToken">カード情報入力済</span>
                    <span v-else>カード情報の入力</span>
                  </v-btn>
                </v-container>

                <v-sheet class="text-caption pa-3 mb-6" outlined>
                  【コンビニエンスストア】<br>
                  日本国内のローソン、ファミリーマート、ミニストップ、デイリーヤマザキ、 セイコーマート、セブンイレブンの店舗で支払いができます。<br>
                  一カ国語受験・・・15,200 円（受験手数料 14,850 円＋事務手続手数料 350 円）<br>
                  二カ国語受験・・・30,248円（受験手数料 29,700円＋事務手続手数料 548円）
                </v-sheet>
                <v-radio
                  label="コンビニ決済"
                  value="convenience"
                ></v-radio>
                <v-container class="text-center text-caption">
                  <!--                <v-btn color="primary" @click="openConveniencePayment" rounded class="white&#45;&#45;text buttonStyle"-->
                  <!--                       :disabled="paymentMethod!='convenience'"-->
                  <!--                >-->
                  <!--                  コンビニ決済を実行する-->
                  <!--                </v-btn>-->
                  願書提出後、「受験願書提出完了メール」が送信されます。<br>
                  願書提出後の画面からコンビニ決済手続きを行うか、メールに記載のURLからも同じ手続きが可能です。<br>
                  <span style="color: red; font-weight: bold;">支払期限内（申込日含む5日間）にお支払いください。<br>
                    ※仕様上「申込日の６日後0:00」表記となっております。<br>
                    願書申請最終日の支払期限は、最終日当日（7月10日）の23：59までです。<br>
                    以降の支払手続きは出来ませんので、ご注意ください。</span>
                </v-container>
              </v-radio-group>

              <p v-if="ticket">
                {{ ticket.name }}<span class="d-none">：{{ ticket.price }} 円(税込)</span><br>
              </p>

              <p class="text-caption text-left">
                観光庁長官試験事務代行機関<br>
                独立行政法人 国際観光振興機構 理事長殿<br>
                下記の個人情報取り扱いについて同意の上、全国通訳案内士試験の受験を申請いたします。<br>
                【個人情報保護方針について】<a href="https://www.jnto.go.jp/site-info/privacy-policy.html"
                                             target="_blank">https://www.jnto.go.jp/site-info/privacy-policy.html</a><br>
                全国通訳案内士試験出願及び試験により取得した個人情報は、全国通訳案内士試験実施事務及び統計目的以外には一切使用することはありません。
              </p>
              <p class="text-caption text-left">
                <span class="text-subtitle-1 font-weight-bold">【願書提出前にご確認ください】</span><br>
                願書提出後の受験科目、選択外国語、受験地、免除申請の変更・追加はできません。<br/>
                その他、ご登録内容をご確認の上、願書を提出してください。<br/>
                受領した受験手数料は、通訳案内士法第10条の規定により返還いたしません。<br/>
                インターネット受験申込みに関する特定商取引法に基づく表示はページ下部よりご確認ください。
              </p>
              <v-btn color="primary" :disabled="!canSubmit" @click.stop="submit" rounded
                     class="white--text buttonStyle">決済を確定して願書を提出する
              </v-btn>
            </template>
            <template v-else>
              <p>提出可能期間ではありません</p>
            </template>

          </v-stepper-content>

          <!--          <v-stepper-step step="4" :complete="!!me.submittedAt">-->
          <!--            <span>出願する-->
          <!--            <v-icon color="green" v-if="!!me.submittedAt">mdi-check-circle</v-icon>-->
          <!--            <v-icon color="gray" v-else>mdi-check-circle</v-icon>-->
          <!--            </span>-->
          <!--          </v-stepper-step>-->
          <!--          <v-stepper-content step="4">-->
          <!--            <p class="text-caption text-left">-->
          <!--              観光庁長官試験事務代行機関<br>-->
          <!--              独立行政法人 国際観光振興機構 理事長殿<br>-->
          <!--              下記の個人情報取り扱いについて同意の上、全国通訳案内士試験の受験を申請いたします。<br>-->
          <!--              【個人情報保護方針について】https://www.jnto.go.jp/jpn/site_info/privacy_policy.html<br>-->
          <!--              全国通訳案内士試験出願及び試験により取得した個人情報は、全国通訳案内士試験実施事務及び統計目的以外には一切使用することはありません。-->
          <!--            </p>-->
          <!--            <v-btn color="primary" :disabled="!canSubmit" @click.stop="submit" rounded-->
          <!--                   class="white&#45;&#45;text buttonStyle">願書を提出する-->
          <!--            </v-btn>-->
          <!--          </v-stepper-content>-->
          <!--                    <v-stepper-step step="5">-->
          <!--                      <span>審査状況:<span v-if="!!me.submittedAt">審査中</span></span>-->
          <!--                    </v-stepper-step>-->
          <!--          <v-stepper-content step="5">-->
          <!--          </v-stepper-content>-->


          <v-stepper-step step="4">
            <span>審査状況</span>
          </v-stepper-step>
          <v-stepper-content step="4" class="open_force">
            <div v-if="!!me.submittedAt">
              <div v-if="me.entryStatus == 'ACCEPTED'">
                審査状況：承認済み
              </div>
              <div v-else-if="me.entryStatus == 'WAIT_FOR_RESUBMIT'">
                <p class="mb-16">審査状況：再提出待ち</p>
                <p class="red--text">登録内容の修正完了後、下記「願書を再提出する」ボタンをクリックしてください</p>
                <v-btn color="primary" :disabled="!canReSubmit" @click.stop="resubmit" rounded
                       class="white--text buttonStyle">願書を再提出する
                </v-btn>
                <p class="red--text" v-if="!canReSubmit">登録内容の修正が確認できません</p>
              </div>
              <div
                v-else-if="me.ticketOrder && me.ticketOrder.paymentMethod == 'SONYPAYMENT_CONVENIENCE_STORE' && me.ticketOrder.result == 'WaitForPayment'">
                <div>
                  審査状況：決済完了待ち
                </div>
              </div>
              <div v-else-if="me.entryStatus == 'PENDING' || me.entryStatus == 'HOLD' || me.entryStatus == 'REJECTED'">
                審査状況：審査中
              </div>
              <div v-else>
              </div>
              <template
                v-if="me.ticketOrder && me.ticketOrder.paymentMethod == 'SONYPAYMENT_CONVENIENCE_STORE' && me.ticketOrder.result == 'WaitForPayment'">
                <v-btn class="primary" to="/api/status/convenience_payment_url" target="_blank" tag="a">
                  コンビニ決済ページへ
                </v-btn>
              </template>
            </div>
          </v-stepper-content>
        </v-stepper>

        <!--        <div class="subTitle"><span>領収書</span></div>-->

        <!--        <v-flex xl8 offset-xl2 xs12 v-if="me.ticketPrice > 0">-->
        <!--          <p class="text-xs-center">-->
        <!--            <v-btn-->
        <!--              color="primary"-->
        <!--              class="white&#45;&#45;text buttonStyle"-->
        <!--              @click="downloadReceipt"-->
        <!--              rounded-->
        <!--            >-->
        <!--              領収書ダウンロード-->
        <!--            </v-btn>-->
        <!--          </p>-->
        <!--        </v-flex>-->

        <!--        <div class="subTitle"><span>試験結果</span></div>-->


        <div class="subTitle">
          <span>お問い合わせ先</span>
        </div>
        <p class="text-left pa-5">
          ＜全国通訳案内士試験事務局＞<br>
          TEL. 04-7131-6200<br>
          （土・日・祝・年末年始除く10：00～17：00）<br>
          ▶お問い合わせは、<a href="https://mdr0028.maildealer.jp/f.php?c=8&s=71bb" target="_blank">こちら</a>からお願いいたします。
        </p>
        <p class="text-left text-caption">
          日本政府観光局(JNTO)は、2025年度の全国通訳案内士試験に係る事務手続き、<br>
          試験運営業務等を日販セグモ株式会社に委託しています。
        </p>

      </v-flex>

      <AccountEdit v-model="changeEmailModal"></AccountEdit>
      <PasswordEdit v-model="changePasswordModal"></PasswordEdit>

    </v-layout>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="640"
    >
      <v-card>
        <v-card-title class="text-h5 font-weight-bold">
          【ご案内】
        </v-card-title>
        <v-card-text class="text-left" style="font-size: 1rem; line-height: 1.5rem">
          <p>
            本試験は、願書申請手続きを始め、受験票の公開、結果通知、合格証書の交付まで、
            すべてインターネット上、電子申請システム内のマイページにて行います。
            手続きする前に必ず施行要領を事前にご確認ください。
          </p>

          <p class="red--text">
            ※受付期間内に願書申請が承認（受験手数料のお支払いを含む）されなかった場合、マイページは消去されます。</p>

          <p>※本画面を閉じる場合は「<span style="color: #43A047">閉じる</span>」をクリックしてください。</p>
        </v-card-text>
        <v-card-actions>
          <!--          <v-checkbox label="以後表示しない" v-model="noDialog"></v-checkbox>-->
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import {getReceiptUrl, getTickets} from '../../utils/VisitorAPIUtils'
import axios from 'axios'
import Loading from '../components/Loading'

import {mapGetters} from 'vuex'
import AccountEdit from '../components/AccountEdit'
import PasswordEdit from '../components/PasswordEdit'
import dayjs from 'dayjs'
import _ from 'lodash';
//No.10 結果通知画面: table module追加
import "quill-table/src/css/quill.table.css";


let isProd = location.hostname == 'pre.shiken.jnto.go.jp' || location.hostname == 'shiken.jnto.go.jp'

function initSpsv() {
  let url = isProd ? process.env.VUE_APP_SONY_SCRIPT_URL : process.env.VUE_APP_SONY_SCRIPT_TEST_URL
  let escott = document.createElement('script')
  escott.setAttribute('src', url)
  escott.setAttribute('callBackFunc', 'spsvCallback')
  escott.setAttribute('class', 'spsvToken')
  document.head.appendChild(escott)
}

export default {
  components: {PasswordEdit, Loading, AccountEdit},
  props: {
    event_data: Object,
  },
  data() {
    return {
      isProd: isProd,
      loading: true,
      stepper: 1,
      tickets: [],
      callbackToken: null,
      callbackCard: null,
      paymentMethod: 0,
      // paymentOk: false,
      changeEmailModal: false,
      changePasswordModal: false,
      dialog: true
    }
  },
  computed: {
    ...mapGetters([
      'event', 'eventInfo', 'me', 'accepted', 'entryOpened', 'isPre'
    ]),
    entryOk() {
      return this.me && this.me.entry && !!this.me.entry.submittedAt
    },
    subjectOk() {
      return this.me && this.me.subjectEntry && !!this.me.subjectEntry.submittedAt
    },
    paymentOk() {
      return this.me && !!this.me.ticketId
    },
    canSubmit() {
      let ret = this.entryOk && this.subjectOk && !!this.ticket && (this.entryOpened || this.isPre)
      if (this.paymentMethod == 'card') {
        return ret && !!this.callbackToken
      }
      return ret
    },
    canReSubmit() {
      let ret = this.entryOk && this.subjectOk
      if (_.has(this.me, "resubmitRequestedAt")) {
        let isChanged = dayjs(_.get(this.me, "entry.submittedAt")).isAfter(this.me.resubmitRequestedAt)
          || dayjs(_.get(this.me, "subjectEntry.submittedAt")).isAfter(this.me.resubmitRequestedAt)
        ret = ret && isChanged
      }
      return ret
    },
    ticket() {
      let ticketCode = null
      let isCard
      switch (this.paymentMethod) {
        case 'card':
          isCard = true
          break
        case 'convenience':
          isCard = false
          break
        default:
          return null
      }
      let hasTwoLanguage = this.me.subjectEntry && !!this.me.subjectEntry.language2 || false
      if (hasTwoLanguage) {
        ticketCode = isCard ? 'TwoLanguageWithCard' : 'TwoLanguageWithConvenienceStore'
      } else {
        ticketCode = isCard ? 'OneLanguageWithCard' : 'OneLanguageWithConvenienceStore'
      }
      return this.tickets.find(v => v.code == ticketCode)
    },
    canShowWrittenTicket() {
      let target = this.event.timeline && this.event.timeline.writtenExamTicketOpenAt
      return !!target && dayjs().isAfter(target)
    },
    canShowWrittenResult() {
      let target = this.event.timeline && this.event.timeline.writtenExamResultOpenAt
      return !!target && dayjs().isAfter(target)
    },
    canShowOralTicket() {
      let target = this.event.timeline && this.event.timeline.oralExamTicketOpenAt
      return !!target && dayjs().isAfter(target)
    },
    canShowOralResult() {
      let target = this.event.timeline && this.event.timeline.oralExamResultOpenAt
      return !!target && dayjs().isAfter(target)
    },
    noDialog: {
      get() {
        return localStorage.getItem('noDialog')
      },
      set(v) {
        localStorage.setItem('noDialog', v);
      }
    },
    eventInfoConditionalTextsOrdered() {
      return (this.eventInfo.conditionalTexts || []).sort((a, b) => {
        if (!a.viewOrderRank) return 1
        if (!b.viewOrderRank) return -1
        return a.viewOrderRank - b.viewOrderRank
      })
    }
  },
  async created() {
    this.loading = true
    initSpsv()
    window.spsvCallback = (token, card) => {
      this.callbackToken = token
      this.callbackCard = card
      // this.authCard()
    }
    await this.$store.dispatch('getMe')
    this.stepper = this.initStepper()

    getTickets({eventId: this.event_data.id}).then(res => {
      this.tickets = res.data
      // this.setTicketStatus();
    }).catch(err => {
      console.log('get tickets catch error. ', err)
    })
    this.loading = false
    // if (!this.noDialog) {
    // this.dialog = false
    // }
  },
  methods: {
    initStepper() {
      if (!this.entryOk) return 1
      if (!this.subjectOk) return 2
      if (!this.me.ticketOrder) return 3
      return 4
    },
    openCardInput() {
      if (window.SpsvApi) {
        window.SpsvApi.spsvCardInfoScreen()
      } else {
        alert('決済ライブラリーの読み込みに失敗しました。時間をあけて再度お試しください')
      }
    },
    async authCard() {
      try {
        await axios.post('/api/status/auth', {
          token: this.callbackToken
        })
        // this.$emit('toast', 'オーソリ成功')
      } catch (e) {
        this.$emit('error', 'こちらのカードはご使用になれません')
      }
    },
    async gatheringCard() {
      try {
        await axios.post('/api/status/gathering', {
          token: this.callbackToken
        })
        this.$emit('toast', '決済が完了しました')
        await this.$store.dispatch('getMe')
        this.stepper = this.initStepper()
        return
      } catch (e) {
        console.error(e, e.response)
        let code = ''
        if (e.response && e.response.data) {
          code = 'エラーコード:' + e.response.data
        }
        this.$emit('error', '決済に失敗しました。' + code)
      }
    },
    async openConveniencePayment() {
      try {
        let {data} = await axios.post('/api/status/add_cnv')
        console.error(data)
        this.$emit('toast', data)
        // return this.getMe()
        window.open(data, 'payment')
        return
      } catch (e) {
        console.error(e, e.response)
        let code = ''
        if (e.response && e.response.data) {
          code = 'エラーコード:' + e.response.data
        }
        this.$emit('error', '決済に失敗しました。' + code)
      }
    },
    async submit() {
      this.loading = true
      try {
        await axios.post('/api/status/submit', {
          paymentMethod: this.paymentMethod,
          maskedCardNumber: this.callbackCard,
          token: this.callbackToken
        })
        this.$emit('toast', '提出しました')
        await this.$store.dispatch('getMe')
        this.stepper = this.initStepper()
        return
      } catch (e) {
        console.error(e)
        let code = ''
        if (e.response && e.response.data) {
          code = 'エラーコード:' + e.response.data
          this.$emit('error', '決済に失敗しました。' + code)
        } else {
          this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
        }
      } finally {
        this.loading = false
      }
    },
    async resubmit() {
      if (!window.confirm("再提出をしてもよろしいですか？")) {
        return false;
      }
      this.loading = true
      try {
        await axios.post('/api/status/resubmit')
        this.$emit('toast', '提出しました')
        await this.$store.dispatch('getMe')
        this.stepper = this.initStepper()
        return
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      } finally {
        this.loading = false
      }
    },
    edit() {

    },
    downloadReceipt() {
      let url = getReceiptUrl({eventId: this.event_data.id})
      window.location.href = url
    },
    rule(info) {
      try {
        return _.get(this.me, info.condition) == info.conditionValue
      } catch (e) {
        console.log(e)
      }
    },
    isLang2writtenResultFailed(me) {
      let detail = me.examResult.resultDetail
      return [detail.writtenGeographyResult,
        detail.writtenHistoryResult,
        detail.writtenCommonSenseResult,
        detail.writtenPracticeResult].some(value => value == '不合格')
    }
  }
}
</script>
<style lang="scss">
.Title {
  font-size: 150%;
}

.subTitle {
  position: relative;
  text-align: left;
  font-size: 130%;
  font-weight: bold;
  color: #959595;
}

.subTitle:before {
  border-top: 1px solid;
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
}

.subTitle span {
  background-color: white;
  display: inline-block;
  padding: 0 0.5em;
  position: relative;
}

.subContentsTitle {
  font-size: 100%;
}

.buttonStyle {
  width: 50%;
}

.open_force.v-stepper__step--editable + .v-stepper__content .v-stepper__wrapper {
  height: auto !important;
}

.resultScore {
  padding-right: 1em;
  text-align: right;
}
// No.8 電子申請ページのレスポンシブ対応
.my-page img {
  max-width: 100%;
}
</style>
